import { Box, CircularProgress } from "@mui/material";

export default function Loader({ fill = true, ...props }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: fill ? "100%" : "80vh",
        ...props.sx,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
